<template>
  <div class="list-wrap" v-if="permission" :class="isSideMenuClosed ? 'collapsed' : ''">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-if="view_influencer_list_enabled && permission.access">
      <div class="header-search-wrap">
        <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
        <!-- <el-input class="head-search list" placeholder="リストを検索" clearable v-model="search_list" @input="searchList($event)"></el-input> -->
        <sortSuggest :referer="'list'" @searchList="searchList" @searchListByInfluencer="searchListByInfluencer" />
      </div>
    </div>
    <!-- ユーザーページ -->
    <div class="list-page-wrap">
      <div class="data-table-title white">
        <div style="display:flex; flex-flow:row; align-items:center">
          <span style="margin-right: 20px;">インフルエンサーリスト</span>
          <div class="list-user-sort-wrap" v-if="list_search">
            <div class="list-user-sort" style="height:42px">
              「{{ list_search_word }}」のリスト
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="clearList('list')" />
            </div>
          </div>
          <div class="list-user-sort-wrap" v-if="list_search_by_influencer">
            <div class="list-user-sort" style="height:42px;">
              <div style="position:relative">
                <img :src="list_search_by_influencer_info.picture_url" class="list-member-profile-sidemenu" @error="imgInfluencerError()" />
                <div class="suggest-sns-type" :class="list_search_by_influencer_info.sns_type"><font-awesome-icon :icon="['fab', list_search_by_influencer_info.sns_type]" /></div>
              </div>
              「{{ list_search_by_influencer_info.suggest_name }}」が含まれるリスト
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="clearList('influencer')" />
            </div>
          </div>
          <div class="list-user-sort-wrap" v-if="client_select.target_client_id != 'all'">
            <div class="list-user-sort">
              <img :src="client_select.img_url" class="list-member-profile-sidemenu" v-if="client_select.img_url != null" />
              <div v-else class="list-member-noimg">{{ client_select.target_client_name | firstLetter }}</div>
              {{ client_select.target_client_name }}のリスト
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="selectClient(all_client)" />
            </div>
          </div>
          <div class="list-user-sort-wrap" v-if="member_select.person_id != 'all'">
            <div class="list-user-sort">
              <img :src="member_select.img_url" class="list-member-profile-sidemenu" v-if="member_select.img_url != null" />
              <div v-else class="list-member-noimg">{{ member_select.person_name | firstLetter }}</div>
              {{ member_select.person_name }}のリスト
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="selectMember(all_member)" />
            </div>
          </div>
          <div class="list-user-sort-wrap" v-if="tag_select.id != 'all'">
            <div class="list-user-sort">
              {{ tag_select.tag_name }}のリスト
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="selectTag(all_tag)" />
            </div>
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="report-title-num-box" v-if="create_influencer_list_limit_num !== null && create_influencer_list_limit_num > 0">
          <div class="report-title-num">
            <div>リスト数</div>
            <div class="report-title-num-bottom">{{ active_list_count }}/{{ create_influencer_list_limit_num }}</div>
          </div>
        </div>
        <div class="data-table-menu" v-if="view_influencer_list_enabled">
          <div class="data-table-menu-archive" v-show="archive">
            <el-tooltip>
              <div class="activate-popover" slot="content">アーカイブ中のリストはステータスを変更することでアーカイブ解除できます</div>
              <div>アーカイブしたリストを表示中</div>
            </el-tooltip>
            <i class="el-icon-error pointer close" @click="archiveOff"></i>
          </div>
          <el-dropdown trigger="click">
            <el-button type="info" style="margin-right:10px">
              アクション
              <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-tooltip :disabled="export_influencer_list_enabled">
                <div class="activate-popover" slot="content">
                  <div class="pointer" @click="toSetting">アップグレード</div>
                  でご利用いただけます
                </div>
                <span>
                  <el-dropdown-item style="font-size:12px;" icon="el-icon-download" :disabled="!export_influencer_list_enabled" @click.native="exportList()">リスト一覧をエクスポート</el-dropdown-item>
                </span>
              </el-tooltip>
              <el-dropdown-item style="font-size:12px;" icon="el-icon-takeaway-box" v-show="view_influencer_list_enabled" @click.native="archiveOn()">アーカイブしたリスト</el-dropdown-item>
              <el-dropdown-item style="font-size:12px;" icon="el-icon-setting" @click.native="openEditTagDrawer()">
                  タグを管理
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip :disabled="!create_list_limited">
            <div slot="content">リストの上限数に達しています</div>
            <span>
              <el-button type="success" icon="el-icon-plus" @click="openCreateList('create')" :disabled="create_list_limited">新規リスト作成</el-button>
            </span>
          </el-tooltip>
        </div>
      </div>

      <el-tabs v-model="list_sns_type" class="tab-report" @tab-click="changeTab($event)">
        <el-tab-pane label="全て" name="all"></el-tab-pane>
        <el-tab-pane name="instagram">
          <div slot="label" class="flex-row">
            <div class="header-sns instagram" slot="label"><font-awesome-icon :icon="['fab', 'instagram']" /></div>
            <div>Instagram</div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="youtube" :disabled="!search_influencer_youtube_enabled">
          <div slot="label" class="flex-row">
            <div class="header-sns youtube" slot="label"><font-awesome-icon :icon="['fab', 'youtube']" /></div>
            <div>YouTube</div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="tiktok" :disabled="!search_influencer_tiktok_enabled">
          <div slot="label" class="flex-row">
            <div class="header-sns tiktok" slot="label"><font-awesome-icon :icon="['fab', 'tiktok']" /></div>
            <div>TikTok</div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="twitter" :disabled="!search_influencer_x_enabled">
          <div slot="label" class="flex-row">
            <div class="header-sns twitter" slot="label">
              <svg width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
              </svg>
            </div>
            <div>X</div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="master">
          <span slot="label"
            >マスターリスト
            <el-tooltip content="個別リストに追加されたインフルエンサー全員を表示できるリストです">
              <font-awesome-icon :icon="['fas', 'question-circle']" />
            </el-tooltip>
          </span>
        </el-tab-pane>
      </el-tabs>

      <!-- テーブルタイトル -->
      <div :class="[header_notification ? 'header-notification-space-120' : '', list_sns_type != 'master' ? 'data-table-list-ignore-master' : 'data-table-list']">
        <listColumn :column="'list_name'" :css="'namearea thread'" :title="'リストタイトル'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <listColumn :column="'influencer_num'" :css="'num'" :title="'人数'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <listColumn :column="'average_engagement_rate'" :css="'num'" :title="'平均EGR'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <listColumn :column="'followers_count'" :css="'followers'" :title="'フォロワー\n合計数'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <listColumn :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <listColumn v-if="list_sns_type != 'master'" :column="'list_status'" :css="'status'" :title="'ステータス'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
        <memberBrandSelect v-if="list_sns_type != 'master'" :type="'client'" :target_client="target_client" @selectClient="selectClient" />
        <memberBrandSelect v-if="list_sns_type != 'master'" :type="'member'" :member="member" @selectMember="selectMember" />
        <listSelectTag v-if="list_sns_type != 'master'" :type="'tag'" :tag_list="tag_list" @selectTag="selectTag" />
        <div class="data-table-th-90" v-if="list_sns_type != 'master'">管理</div>
      </div>

      <!-- テーブルループ -->
      <unpermitted v-if="!permission.access" />
      <div class="data-table-list-nolist" v-if="permission.access && nolist && view_influencer_list_enabled && list_sns_type != 'master'">
        <img src="../../assets/list_image.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:700; margin-bottom:15px;">リストがありません</div>
        <div class="data-table-list-nolist-content">
          インフルエンサーを登録・管理・比較できます。
          <br />リストを作成すると、EXCELファイルのエクスポートができるようになります。
        </div>
        <el-button type="success" @click="openCreateList('create')" icon="el-icon-plus">新規リスト作成</el-button>
      </div>
      <div class="data-table-list-nolist" v-if="permission.access && nolist && view_influencer_list_enabled && list_sns_type == 'master'">
        <img src="../../assets/list_image.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:700; margin-bottom:15px;">マスターリストがありません</div>
        <div class="data-table-list-nolist-content">
          インフルエンサーを個別リストに追加・削除すると、自動でマスターリストが作成・更新されます。
        </div>
        <el-button type="success" @click="openCreateList('create')" icon="el-icon-plus">新規リスト作成</el-button>
      </div>
      <div class="data-table-list-nolist" v-else-if="permission.access && !view_influencer_list_enabled">
        <img src="../../assets/list_image.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:700; margin-bottom:15px;">リストがありません</div>
        <div class="data-table-list-nolist-content">
          インフルエンサーを登録・管理・比較できます。
          <br />リストを作成すると、EXCELファイルのエクスポートができるようになります。
        </div>
        <el-tooltip placement="top">
          <div class="activate-popover" slot="content">
            <div class="pointer" @click="toSetting">アップグレード</div>
            でご利用いただけます
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" disabled>新規リスト作成</el-button>
          </div>
        </el-tooltip>
      </div>

      <div v-for="(list, index) in list" :key="list.id" class="data-table-list-tr" v-show="view_influencer_list_enabled && !nolist && permission.access">
        <div
          class="data-table-list-openwrap pointer"
          @click.exact="listOpen(list.list_id, list.list_status, index)"
          @click.ctrl.exact="listOpenNewWindow(list.list_id, list.list_status)"
          @click.meta.exact="listOpenNewWindow(list.list_id, list.list_status)"
        >
          <div class="data-table-list-imagearea">
            <div class="data-table-list-image">
              <div class="i-detail-header-sns-type" :class="list.sns_type">
                <svg v-if="list.sns_type === 'twitter'" width="9" height="9" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                </svg>
                <font-awesome-icon v-else :icon="['fab', list.sns_type]" />
              </div>
              <img :src="list.img_url" class="list_img" v-if="list.img_url != null" />
              <div class="data-table-list-noimg" v-else>
                <font-awesome-icon :icon="['fal', 'list']" />
              </div>
            </div>
          </div>
          <div class="data-table-list-name">
            <div class="data-table-list-name-name">
              <div v-html="$options.filters.fontBold(list.list_name, list_search_word)"></div>
            </div>
            <div class="data-table-list-name-sub">
              <span v-if="list.target_client_name != null">{{ list.target_client_name }}・</span>
              最終更新&nbsp;{{ list.update_at | lastUpadate }}
            </div>
          </div>
          <div class="data-table-list-num" style="padding: 0px 10px;">{{ list.influencer_num == 0 ? "-" : list.influencer_num }}</div>
          <div class="data-table-list-num" style="padding: 0px 10px;">{{ list.average_engagement_rate == 0 ? "-" : list.average_engagement_rate + "%" }}</div>
          <div class="data-table-list-followers" style="padding: 0px 10px;">{{ list.followers_count | addComma }}</div>
          <div class="data-table-list-gender" style="padding-left: 10px;">
            <genderRatio :female_ratio="list.female_ratio" :male_ratio="list.male_ratio" />
          </div>
        </div>

        <statusDropdown v-if="list_sns_type != 'master'" :id="list.list_id" :list="list" :index="index" @changeListStatus="changeListStatus" />
        <brandDropdown
          v-if="list_sns_type != 'master'"
          :id="list.list_id"
          :list="list"
          :target_client="target_client"
          :index="index"
          @changeTargetClient="changeTargetClient"
          @deleteClient="deleteClient"
        />
        <memberDropdown v-if="list_sns_type != 'master'" :id="list.list_id" :list="list" :index="index" @addMember="addMember" @deleteMember="deleteMember" />
        <tagDropdown v-if="list_sns_type != 'master'" :id="list.list_id" :list="list" :tag_list="tag_list" :index="index" @addTag="addTag" @removeTag="removeTag" @openEditTagDrawer="openEditTagDrawer" />
        <listManageButton v-if="list_sns_type != 'master'" :list="list" :index="index" @openCreateList="openCreateList" @deleteList="deleteList" />
      </div>

      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler" v-if="view_influencer_list_enabled && permission.access">
        <div slot="no-more"></div>
        <div slot="no-results" style="font-size:40px;"></div>
      </infinite-loading>
    </div>

    <createList
      :create_list.sync="create_list"
      :type="create_list_type"
      :target_list_name="target_list_name"
      :target_list_id="target_list_id"
      :target_list_index="target_list_index"
      @loadList="loadList"
      @changeListName="changeListName"
    />
    <tagDrawer :drawer="drawer" @closeDrawer="closeEditTagDrawer" @loadTag="loadTag" @loadList="loadList" />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListAPI = root + "/api/list/load_list";
const loadTagAPI = root + "/api/list/load_tag";
const changeListAPI = root + "/api/list/change_list";
const deleteListAPI = root + "/api/list/delete_list";
const exportListAPI = root + "/api/list/export_list";
const loadMemberAPI = root + "/api/member/load_member";
const addMemberAPI = root + "/api/list/add_member";
const addTagAPI = root + "/api/list/add_tag";
const removeTagAPI = root + "/api/list/remove_tag";
const deleteMemberFromListAPI = root + "/api/list/delete_member_list";
import createList from "./createList";
import genderRatio from "./gender_ratio";
import brandDropdown from "./list_dropdown_brand";
import memberDropdown from "./list_dropdown_member";
import tagDropdown from "./list_dropdown_tag";
import statusDropdown from "./list_dropdown_status";
import listManageButton from "./list_manage_button";
import sortSuggest from "./list_sort_suggest";
import listColumn from "./list_column";
import memberBrandSelect from "./list_select_member";
import listSelectTag from "./list_select_tag";
import unpermitted from "./../unpermitted";
import tagDrawer from "./tag_drawer.vue";

export default {
  name: "list",
  components: {
    createList,
    genderRatio,
    brandDropdown,
    memberDropdown,
    tagDropdown,
    statusDropdown,
    listManageButton,
    sortSuggest,
    listColumn,
    memberBrandSelect,
    listSelectTag,
    unpermitted,
    tagDrawer,
  },
  // props: ["account_name", "followers", "category"],
  data() {
    return {
      activeName: "all",
      list: [],
      active_list_count: 0,
      result_count: 0,
      open_list_id: "",
      open_list_followers_count: 0,
      member: [],
      target_client: [],
      tag_list: [],
      create_list: false,
      list_name: "",
      sort_key: "",
      sort_order: "",
      infiniteId: +new Date(),
      listIsOpen: false,
      nolist: false,
      count: 0,
      drawer: false,
      index: 0,
      archive: false,
      search_list: "",
      search_list_regexp: "",
      loading: false,
      scrollY: 0,
      scrollX: 0,
      all_member: {
        person_id: "all",
      },
      all_client: {
        target_client_id: "all",
      },
      all_tag: {
        id: "all",
      },
      list_search_word: "",
      list_search: false,
      list_search_by_influencer: false,
      list_search_by_influencer_info: {},
      influencer_search: false,
      offset: 0,
      requestId: 0,
      create_list_type: "",
      target_list_id: -1,
      target_list_name: "",
      target_list_index: -1,
      load_type: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.list;
    },
    activate() {
      return this.$store.state.activate;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
    tag_select() {
      return this.$store.state.tag_select;
    },
    create_influencer_list_limit_num() {
      return this.$store.state.service_plan.create_influencer_list_limit_num;
    },
    export_influencer_list_enabled() {
      return this.$store.state.service_plan.export_influencer_list_enabled ? true : false;
    },
    search_influencer_youtube_enabled() {
      return this.$store.state.service_plan.search_influencer_youtube_enabled;
    },
    search_influencer_tiktok_enabled() {
      return this.$store.state.service_plan.search_influencer_tiktok_enabled;
    },
    search_influencer_x_enabled() {
      return this.$store.state.service_plan.search_influencer_x_enabled;
    },
    view_influencer_list_enabled() {
      return this.$store.state.service_plan.view_influencer_list_enabled;
    },
    list_sns_type: {
      get() {
        return this.$store.state.list_sns_type;
      },
      set(sns_type) {
        this.$store.dispatch("changeListSnsType", sns_type);
      },
    },
    create_list_limited() {
      if (this.create_influencer_list_limit_num === null) return false;
      return this.active_list_count >= this.create_influencer_list_limit_num ? true : false;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
    // list_search() {
    //   return this.$store.state.list_search;
    // },
    // list_search_word() {
    //   return this.$store.state.list_search_word;
    // },
  },
  mounted() {
    this.$store.dispatch("changeActive", "list");
    this.loadMember();
    this.loadTag();
    this.$nextTick(() => {
      this.infiniteId += 1;
    });
  },
  methods: {
    infiniteHandler($state) {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadListAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            user_token: this.user_token,
            offset: this.offset,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
            select_tag_id: this.tag_select.id,
            archive: this.archive,
            search_word: this.list_search_word,
            search_word_by_influencer: this.list_search_by_influencer_info.influencer_id,
            search_word_by_influencer_sns_type: this.list_search_by_influencer_info.sns_type,
            sns_type: this.list_sns_type,
            type: this.load_type,
          },
        })
        .then((response) => {
          if (this.offset == 0) {
            this.list = response.data.mylist;
            this.result_count = response.data.result_count;
          } else {
            var newList = this.list.concat(response.data.mylist);
            this.list = newList;
          }
          this.offset += 20;
          $state.loaded();
          if (this.result_count <= this.offset) $state.complete();
          this.active_list_count = response.data.active_list_count;
          if (this.result_count == 0) this.nolist = true;
          else this.nolist = false;
        });
    },
    loadList() {
      this.offset = 0;
      this.list = [];
      this.infiniteId += 1;
    },
    changeTab(event) {
      if (event.name == "master") {
        this.selectMember(this.all_member);
        this.selectClient(this.all_client);
        this.selectTag(this.all_tag);
        this.list_search_word = "";
        this.list_search = false;
      }
      this.nolist = false;
      this.$store.dispatch("changeListSnsType", event.name);
      this.loadList();
    },
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.member = response.data.member;
          this.target_client = response.data.target_client;
        });
    },
    loadTag() {
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
        })
        .catch(() => {});
    },
    openCreateList(type, target_list_name, target_list_id, target_list_index) {
      if (this.permission.edit) {
        this.create_list_type = type;
        this.target_list_name = target_list_name;
        this.target_list_id = target_list_id;
        this.target_list_index = target_list_index;
        this.create_list = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    selectTag(tag) {
      this.$store.dispatch("selectTag", tag);
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    changeListName(list_name, index) {
      this.list[index].list_name = list_name;
      this.target_list_name = "";
      this.target_list_id = -1;
      this.target_list_index = -1;
    },
    changeListStatus(value, id, index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("change_type", "status");
        params.append("list_status", value);
        params.append("list_id", id);
        params.append("token", this.token);
        this.axios.post(changeListAPI, params).then((response) => {
          if (response.data.status == "OK") {
            this.list[index].list_status = value;
            this.$nextTick(() => {
              if (value == "アーカイブ") {
                this.$message({
                  type: "success",
                  offset: 7,
                  showClose: true,
                  message: "「" + value + "」に変更しました。アーカイブ中のリストは「アクション」→「アーカイブ一覧」で閲覧できます。",
                });
              } else {
                this.$message({
                  type: "success",
                  offset: 7,
                  showClose: true,
                  message: "ステータスを「" + value + "」に変更しました",
                });
              }
            });
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            });
          }
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteList(name, id, index) {
      if (this.permission.edit) {
        const h = this.$createElement;
        const list_id = id;
        this.$msgbox({
          title: "リスト削除",
          type: "warning",
          message: h("p", null, [h("span", null, "「" + name + "」を削除しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
          showCancelButton: true,
          confirmButtonClass: "danger",
          confirmButtonText: "削除",
          cancelButtonText: "キャンセル",
        }).then(() => {
          var params = new URLSearchParams();
          params.append("list_id", list_id);
          params.append("token", this.token);
          this.axios.post(deleteListAPI, params).then(() => {
            this.list.splice(index, 1);
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "「" + name + "」を削除しました",
            });
          });
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    exportList() {
      if (this.permission.access && this.$store.state.permission.export.access) {
        this.$confirm("リスト一覧をエクスポートしますか？（リストはxlsx形式でエクスポートされます）", "リストエクスポート", {
          distinguishCancelAndClose: true,
          type: "info",
          confirmButtonText: "ダウンロード",
          cancelButtonText: "キャンセル",
        }).then(() => {
          location.href = exportListAPI + "?token=" + this.token + "&user_token=" + this.user_token;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    addMember(person_id, member_index, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("person_id", person_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(addMemberAPI, params).then(() => {
          this.list[list_index].member_count += 1;
          this.list[list_index].member[member_index].assign = true;
          this.list[list_index][person_id] = true;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    addTag(tag_id, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("tag_id", tag_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(addTagAPI, params).then(() => {
          this.list[list_index].tag.push({
            mylist_list_id: list_id,
            mylist_tag_id: tag_id
          })
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteMember(person_id, member_index, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("member_type", "member");
        params.append("person_id", person_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(deleteMemberFromListAPI, params).then(() => {
          this.list[list_index].member_count -= 1;
          this.list[list_index].member[member_index].assign = false;
          this.list[list_index][person_id] = false;
          if (person_id == this.member_select.person_id) this.list.splice(list_index, 1);
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    removeTag(tag_id, tag_index, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("tag_id", tag_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(removeTagAPI, params).then(() => {
          this.list[list_index].tag.splice(tag_index, 1);
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeTargetClient(target_client_id, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("change_type", "target_client");
        params.append("target_client_id", target_client_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(changeListAPI, params).then((response) => {
          this.list[list_index].target_client_img_url = response.data.list_info.img_url;
          this.list[list_index].target_client_id = response.data.list_info.target_client_id;
          this.list[list_index].target_client_name = response.data.list_info.target_client_name;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteClient(target_client_id, list_id, list_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("member_type", "client");
        params.append("person_id", target_client_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(deleteMemberFromListAPI, params).then(() => {
          this.list[list_index].target_client_id = null;
          this.list[list_index].target_client_name = null;
          if (target_client_id == this.client_select.target_client_id) this.list.splice(list_index, 1);
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    listOpen(id, status) {
      if (status == "アーカイブ") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "アーカイブ中のリストは開けません。アーカイブを解除してください。",
        });
      } else {
        this.$router.push({
          name: "listDetail",
          params: { list_id: id },
        });
      }
    },
    listOpenNewWindow(id, status) {
      if (status == "アーカイブ") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "アーカイブ中のリストは開けません。アーカイブを解除してください。",
        });
      } else {
        let routeData = this.$router.resolve({
          name: "listDetail",
          params: { list_id: id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.offset = 0;
      this.sort_key = value;
      this.list = [];
      this.infiniteId += 1;
    },
    toSetting() {
      this.$router.push("/setting");
    },
    archiveOn() {
      this.archive = true;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    archiveOff() {
      this.archive = false;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    imgError(index) {
      this.list[index].img_error = true;
    },
    imgMemberError(index, type, list_index) {
      if (type == "all") {
        this.member[index].img_error = true;
      } else if (type == "list") {
        this.list[list_index].member[index].img_error = true;
      }
    },
    imgMemberSelectError() {
      this.member_select.img_error = true;
    },
    imgInfluencerError() {
      this.list_search_by_influencer_pic_url = this.s3BaseUrl + "/userdata/img_error_user.png";
    },
    searchList(value) {
      // this.$store.dispatch("searchList", { list_search_word: value, list_search: true });
      if (this.list_sns_type == "master") this.list_sns_type = "all";
      this.list_search_word = value;
      this.list_search = true;
      this.list_search_by_influencer_info = {};
      this.list_search_by_influencer = false;
      this.nolist = false;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    searchListByInfluencer(influencer_info) {
      this.load_type = "influencer";
      this.list_sns_type = influencer_info.sns_type;
      this.list_search_by_influencer_info = influencer_info;
      this.list_search_by_influencer = true;
      this.list_search_word = "";
      this.list_search = false;
      this.nolist = false;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    clearList(type) {
      // this.$store.dispatch("searchList", { list_search_word: "", list_search: false });
      if (type == "list") {
        this.list_search_word = "";
        this.list_search = false;
      } else if (type == "influencer") {
        this.list_search_by_influencer_info = {};
        this.list_search_by_influencer = false;
        this.load_type = "";
        this.sns_type = "all";
      }
      this.nolist = false;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    sidemenuScroll() {
      this.$emit("sidemenuScroll");
    },
    openEditTagDrawer() {
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
    },
    closeEditTagDrawer() {
      this.drawer = false;
      document.documentElement.style.overflow = "auto";
    },
  },
  watch: {
    list() {
      this.$forceUpdate();
    },
  },
  filters: {
    addComma(val) {
      if (val == 0) {
        return "-";
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
    thousandYen(val) {
      return Math.floor(val / 10000).toLocaleString();
    },
    lastUpadate(val) {
      const now = new Date();
      const lastUpdate = new Date(val);
      const diffSec = now.getTime() - lastUpdate.getTime();
      if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
    firstLetter(val) {
      return val.slice(0, 1);
    },
    fontBold(value, search_word) {
      return value.replace(new RegExp(search_word, "ig"), (search_word) => '<span class="data-table-th-highlight">' + search_word + "</span>");
    },
    // search_list(value) {
    //   return RegExp(value, "ig");
    // }
  },
};
</script>
